module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00041-fs8.0a7b5a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00041-fs8.png
// module id = 194
// module chunks = 0